import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const HiddenIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            fill="currentColor"
            d="M20.26,17.55c1.82-1.69,3.05-3.68,3.64-5.06.14-.31.14-.67,0-.99-.62-1.43-1.93-3.53-3.88-5.28-1.96-1.76-4.65-3.24-8.02-3.24-2.72,0-4.99.96-6.81,2.26L1.46,2.2c-.39-.32-.96-.25-1.27.16-.31.4-.23.99.16,1.32l3.39,2.76,1.54,1.26,2.11,1.72,2.93,2.4,3.51,2.87,1.57,1.27,1.83,1.5,1.58,1.29,3.74,3.05c.39.32.95.25,1.26-.16s.24-1-.15-1.32c0,0-3.4-2.77-3.4-2.77ZM11.71,10.57c.19-.34.29-.73.29-1.15,0-.22-.03-.44-.08-.64h.08c1.84,0,3.33,1.44,3.33,3.22,0,.46-.1.9-.28,1.29l-3.34-2.72ZM16.62,14.57c.46-.77.71-1.66.71-2.57,0-1.37-.56-2.68-1.56-3.65-1-.96-2.36-1.51-3.77-1.51-1.25,0-2.45.43-3.4,1.19l-1.83-1.49c1.46-.98,3.21-1.63,5.23-1.63,2.72,0,4.95,1.19,6.66,2.73,1.6,1.44,2.71,3.15,3.28,4.36-.56,1.19-1.65,2.87-3.21,4.29,0,0-2.11-1.72-2.11-1.72Z"
         />
         <path
            fill="currentColor"
            d="M12,17.16c.73,0,1.44-.16,2.1-.44l-1.86-1.52c-.08,0-.16.02-.24.02-1.73,0-3.13-1.28-3.3-2.91l-1.88-1.53c-.1.39-.16.8-.16,1.22,0,1.37.56,2.68,1.56,3.64,1,.97,2.35,1.52,3.77,1.52h0Z"
         />
         <path
            fill="currentColor"
            d="M15.92,18.2c-1.16.55-2.47.89-3.92.89-2.72,0-4.95-1.19-6.67-2.73-1.6-1.44-2.71-3.15-3.27-4.36.42-.92,1.18-2.13,2.22-3.29l-1.53-1.25C1.48,8.89.58,10.4.1,11.5c-.13.32-.13.68,0,.99.62,1.44,1.92,3.54,3.87,5.29,1.97,1.76,4.66,3.24,8.03,3.24,2.13,0,3.98-.6,5.56-1.48,0,0-1.64-1.34-1.64-1.34Z"
         />
      </svg>
   )
}

export default HiddenIcon
